import React from 'react';
import SMSearchListTableRow from '../search/SMSearchListTableRow';
import SMAppHelper from 'components/helpers/SMAppHelper';

class SMRoomCarouselView extends React.Component {

  constructor(props) {
    super(props);
  }

  slickable() {
    $(this.refs.carousel).slick({
      slidesToShow: 3,
      slidesToScroll: 3,
      speed: 300,
      swipe: false,
      arrows: true,
      infinite: false,
      prevArrow: $(this.refs.prev),
      nextArrow: $(this.refs.next),
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll:1 
          }
        },
      ]
    });
  }

  componentDidMount() {
    if (!SMAppHelper.isMobile()) {
      this.slickable();
    }
  }

  favoriteDidSelect(favorable, isFavorite, rowIndex){
    if(this.props.delegate && typeof this.props.delegate.favoriteDidSelectInCarousel === 'function'){
      this.props.delegate.favoriteDidSelectInCarousel(favorable, isFavorite, rowIndex, this.props.tag);
    }
  }

  next(e) {
    e.preventDefault();
  }
  
  prev(e) {
    e.preventDefault();
  }
  
  render() {
    if (!this.props.rooms || this.props.rooms.length == 0) return null;
    let rows = [];
    this.props.rooms.forEach((room, index) => {
      rows.push(
        <SMSearchListTableRow
          key={room.id}
          room={room}
          noRoomImage={this.props.noRoomImage}
          rowIndex={index} 
          canSlide={false}
          delegate={this}
          options={{className: "col-xs-12 col-md-4 units-item"}}
          latestUpdatedFavoriteList={this.props.latestUpdatedFavoriteList}
        />
      );
    });

    return(
      <div className="container">
        <h2 className="page-subtitle">{this.props.title}</h2>
        <div className="mod__units-item flexslider">
          <ul className="row" ref="carousel">
            {rows}
          </ul>
          <div className="mod__units-item__arrow sm-hide">
            <a ref="prev" onClick={this.prev.bind(this)} href="#" className="is-hover"><i className="fa fa-chevron-left"></i></a>
            <a ref="next" onClick={this.next.bind(this)} href="#" className="is-hover"><i className="fa fa-chevron-right"></i></a>
          </div>
        </div>
      </div>
    );
  }

}
export default SMRoomCarouselView;



// WEBPACK FOOTER //
// ./app/javascript/components/rooms/SMRoomCarouselView.jsx